/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_BackdropInputs */

const en_update_backdrop = /** @type {(inputs: Update_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Backdrop`)
};

const id_update_backdrop = /** @type {(inputs: Update_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui Latar Belakang`)
};

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const es_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const fr_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const de_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const ja_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const zh_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const ar_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const it_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const ru_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const pt_update_backdrop = en_update_backdrop;

/** @type {(inputs: Update_BackdropInputs) => LocalizedString} */
const ko_update_backdrop = en_update_backdrop;

/**
* | output |
* | --- |
* | "Update Backdrop" |
*
* @param {Update_BackdropInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const update_backdrop = /** @type {((inputs?: Update_BackdropInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_BackdropInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_update_backdrop(inputs)
	if (locale === "es") return es_update_backdrop(inputs)
	if (locale === "fr") return fr_update_backdrop(inputs)
	if (locale === "de") return de_update_backdrop(inputs)
	if (locale === "ja") return ja_update_backdrop(inputs)
	if (locale === "zh") return zh_update_backdrop(inputs)
	if (locale === "ar") return ar_update_backdrop(inputs)
	if (locale === "id") return id_update_backdrop(inputs)
	if (locale === "it") return it_update_backdrop(inputs)
	if (locale === "ru") return ru_update_backdrop(inputs)
	if (locale === "pt") return pt_update_backdrop(inputs)
	return ko_update_backdrop(inputs)
});